import { TYPES } from './constants';

const YOTPO_SOURCE = 'Yotpo';

export function buildAggregateRating(rating = {}, options = {}) {
  if (!rating?.average || !rating?.ratingCount) return undefined;

  const average = Number(rating.average);
  const ratingCount = Number(rating.ratingCount);
  if (isNaN(average) || average <= 0 || !ratingCount) return undefined;

  const rawReviewCount = Number(rating.reviewCount ?? rating.ratingCount);
  const reviewCount =
    !isNaN(rawReviewCount) && rawReviewCount > 0
      ? Math.min(rawReviewCount, ratingCount)
      : ratingCount;

  const result = {
    '@type': TYPES.aggregate_rating,
    ratingValue: parseFloat(average.toFixed(1)),
    ratingCount,
    reviewCount,
    bestRating: options.bestRating ?? 5,
    worstRating: options.worstRating ?? 1,
  };

  if (options.source) {
    result.author = {
      '@type': TYPES.organization,
      name: options.source,
    };
  }

  if (options.itemReviewed) {
    result.itemReviewed = options.itemReviewed;
  }

  return result;
}

// Build Yotpo aggregateRating for nested Product/ProductGroup schema on PDPs.
export function buildYotpoRating({ average, ratingCount, reviewCount, bestRating, worstRating }) {
  return buildAggregateRating(
    { average, ratingCount, reviewCount },
    {
      bestRating,
      worstRating,
      source: YOTPO_SOURCE,
    },
  );
}
